import React from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck } from "lucide-react"; // Icône différente pour différencier

const PracticeCard = ({ practice }) => {
  return (
    <div className="bg-white shadow-md border rounded-2xl p-3 sm:p-6 max-w-lg h-full flex flex-col justify-between mx-auto">
      <div className="text-orange-500 mb-3">
        <ClipboardCheck size={24} />
      </div>

      <h2 className="text-lg font-bold  md:my-4">{practice.name}</h2>

      <p className="text-gray-500 mb-5 leading-snug line-clamp-4">
        {practice.description || "Aucune description disponible."}
      </p>

      <Link
        to={`/pratique/${practice.id}`}
        className="inline-block border text-md sm:text-lg border-black text-black font-medium py-1 sm:py-2 px-4 sm:px-6 rounded-full hover:bg-orange-500 hover:text-white hover:border-none transition w-full text-center no-underline"
      >
        Commencer
      </Link>
    </div>
  );
};

export default PracticeCard;
